import styled from 'styled-components';
import * as palette from '../../styles/variables';


export const GetStarted = styled.div`
  margin: 0 10px;
  button:hover {
    cursor: pointer;
  }
  button {
    pointer-events: ${props => props.disabled && 'none'} !important;
    opacity: ${props => props.disabled && '0.5'}!important;
    font-size: ${props => (props.large ? '16px' : props.medium ? '14px' : '12px')}!important;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    background-color: ${props =>
      props.backgroundColor === 'primary'
        ? palette.APP_BRAND_YELLOW_COLOR
        : props.backgroundColor === 'danger'
        ? '#ff5430'
        : '#000000'}!important;
    border: ${palette.APP_BRAND_YELLOW_COLOR};
    color: ${props => (props.fontColor === 'primary' ? palette.BLACK_COLOR : '#ffffff')}!important;
    position: relative;
    overflow: hidden;
    font-weight: 700 !important;
    letter-spacing: 1px;
    line-height: 1.3;
    padding: 18px;
    text-transform: uppercase;
    border-radius: ${props =>
      props.borderRadius === 'large'
        ? '64px'
        : props.borderRadius === 'medium'
        ? '42px'
        : '18px'}!important;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
    ${props => props.enableShadow &&`
      box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    `};
  }
  button:hover:before {
    opacity: 1;
    transform: translate(0, 0);
  }
  button:before {
    content: attr(data-hover);
    position: absolute;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    opacity: 0;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
  }
  button:hover div {
    opacity: 0;
    transform: translate(0, -100%);
  }
  button div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
  .loading {
    font-size: 18px;
  }
`;